import { Route } from 'react-router';
import { Page } from '@roc/feature-app-core';

import { MainScreen } from '@roc/feature-comp-tool-v2';


export const getCompToolRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    compTool: {
      path: `${basePath}/backoffice/comp-tool`,
      url: `${baseUrl}/backoffice/comp-tool`,
      documentTitle: 'Comp Tool',
    }
  };
}

export const getCompToolRoutes = (basePath: string, baseUrl: string) => {
  const config = getCompToolRoutesConfig(basePath, baseUrl);
  return {
    compTool: (
      <Route exact path={config.compTool.path}>
        <Page routeDefinition={config.compTool}>
          <MainScreen />
        </Page>
      </Route>
    )
  };
};
